export const techStack = [
    {
        name: "HTML",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
    },
    {
        name: "CSS",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain.svg",
    },
    {
        name: "SCSS",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sass/sass-original.svg",
    },
    {
        name: "Tailwind CSS",
        link: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
    },
    {
        name: "Jquery",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jquery/jquery-plain.svg",
    },
    {
        name: "Javascript",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
    },
    {
        name: "Typescript",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-plain.svg"
    },
    {
        name: "React",
        link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg",
    },
    {
        name: "Redux",
        link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg",
    },
    {
        name: "Ruby",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/ruby/ruby-plain.svg",
    },
    {
        name: "Mongo DB",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain.svg",
    },
    {
        name: "Express",
        link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original-wordmark.svg",
    },
    {
        name: "NodeJS",
        link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg",
    },
    {
        name: "Git",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg",
    },
    {
        name: "Bitbucket",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bitbucket/bitbucket-original.svg"
    },
    // {
    //     name: "Ruby Mine",
    //     link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/rubymine/rubymine-plain.svg",
    // },
    {
        name: "Postman",
        link: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
    },
    {
        name: "VS Code",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg",
    },
    {
        name: "Bash",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bash/bash-original.svg",
    },
    {
        name: "Ubuntu",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/ubuntu/ubuntu-plain.svg",
    },
    {
        name: "Wordpress",
        link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/wordpress/wordpress-plain.svg",
    },
];

export const contactLinks = [
    // {
    //     name: "Instagram",
    //     url: "https://img.icons8.com/doodle/40/000000/instagram-new--v2.png",
    //     link: "https://www.instagram.com/",
    // },
    {
        name: "Github",
        url: "https://img.icons8.com/doodle/40/000000/github--v1.png",
        link: "https://github.com/Akshay-Singh-Rajput",
    },
    {
        name: "LinkedIn",
        url: "https://img.icons8.com/doodle/40/000000/linkedin--v2.png",
        link: "https://www.linkedin.com/in/akshay-kumar046203/",
    },
];

export const serviceData = [
    {
        name: "Web Application Development",
        desc: "Web design encompasses many different skills and disciplines in the production and maintenance of websites. The different areas of web design include web graphic design user interface design  authoring, including standardised code and proprietary software user experience design and search engine",
        img: "https://img.icons8.com/external-kiranshastry-lineal-color-kiranshastry/64/000000/external-web-development-coding-kiranshastry-lineal-color-kiranshastry.png",
    },
    {
        name: "Mobile Application Development",
        desc: `We provide a range of mobile application development services
    including custom mobile development on Android platforms, building
    cross-platform apps, designing user experience and integrating
    novel mobile interfaces such as chat and voice`,
        img: "https://img.icons8.com/external-justicon-lineal-color-justicon/64/000000/external-app-development-responsive-web-design-justicon-lineal-color-justicon.png",
    },

    {
        name: "Backend Development",
        desc: `Graphic design is a craft where professionals create visual
    content to communicate messages. By applying visual hierarchy and
    page layout techniques, designers use typography and pictures to
    meet users' specific needs and focus on the logic of displaying
    elements in interactive designs, to optimize the user experience.`,
        img: "https://img.icons8.com/external-flaticons-flat-flat-icons/64/000000/external-backend-no-code-flaticons-flat-flat-icons.png",
    },
];
